const transactionDat = [
  {
    value: 1,
    label: 'Tiền phòng'
  },
  {
    value: 2,
    label: 'Buồng phòng'
  },
  {
    value: 3,
    label: 'Spa + Karaoke'
  },
  {
    value: 4,
    label: 'Nhà hàng'
  },
  {
    value: 5,
    label: 'Vé'
  },
  {
    value: 6,
    label: 'Phụ phí'
  },
  {
    value: 7,
    label: 'Khác'
  }
]

export { transactionDat }
